<template>
    <u-btn-text-pill v-bind="$attrs" color="secondary" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-text-pill>
</template>

<script>
import UBtnTextPill from "@/components/publish/styles/buttons/u-btn-text-pill.vue";

export default {
    props: {},
    components: {
        UBtnTextPill,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
